<template>
  <div>
    <el-divider>{{ year }} 年 品牌/红人/行业 维度的单量/订单金额
      <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false" title="点击刷新"
               @click="getData"><i
          class="el-icon-refresh-right"/></el-link>

      <export-link @export="exportExcel" ref="refExportLink" :lint-title="``" :can-export="true"/>
    </el-divider>

    <el-row :gutter="20">
      <el-col :span="8" style="padding: 0 10px">
        <el-table class="dashboard-table"
                  show-summary
                  :summary-method="getSummaries"
                  :data="dataBrand"
                  style="width: 100%">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="brand_name" label="品牌" align="center"/>
          <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`" align="right"
                           header-align="right" sortable>
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_count" label="订单数" align="right" header-align="right" sortable/>
        </el-table>
      </el-col>
      <el-col :span="8" style="padding: 0 10px">
        <el-table class="dashboard-table"
                  show-summary
                  :summary-method="getSummaries"
                  :data="dataArtist"
                  style="width: 100%">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="artist_name" label="红人" align="center"/>
          <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`" align="right"
                           header-align="right" sortable>
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_count" label="订单数" align="right" header-align="right" sortable/>
        </el-table>
      </el-col>
      <el-col :span="8" style="padding: 0 10px">
        <el-table class="dashboard-table"
                  show-summary
                  :summary-method="getSummaries"
                  :data="dataTrade"
                  style="width: 100%">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="trade" label="行业" align="center"/>
          <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`" align="right"
                           header-align="right" sortable>
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_count" label="订单数" align="right" header-align="right" sortable/>
        </el-table>
      </el-col>
    </el-row>
  </div>

</template>

<script>
import { exportPlatformDetail, platformDetailArtist, platformDetailBrand, platformDetailTrade } from "@/api/dashboard";

export default {
  name: "otherModule",
  components: {},
  props: {
    searchCondition: {
      type: Object,
      default() {
        return {
          year: 2021,
          platformName: '--',
          platformCode: null,
        }
      }
    },
    year: [Number, String],
    platformName: [String]
  },
  data() {
    return {
      dataBrand: [],
      dataArtist: [],
      dataTrade: [],
      total_count: 0,
      total_money: 0
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.dataBrand = [];
      this.dataArtist = [];
      this.dataTrade = [];
      const form = {
        year: this.searchCondition.year,
        organization_id: this.searchCondition.organization_id,
        platform_name: this.searchCondition.platformName,
        platform_code: this.searchCondition.platformCode
      }
      platformDetailBrand(form).then((res) => {
        // this.dataBrand = res.model.data || []
        let dataBrand = res.model.data || []
        this.dataBrand = dataBrand.map(item => {
          item.order_count = item.order_count * 1
          item.order_money = item.order_money * 1
          return item
        })
      });
      platformDetailArtist(form).then((res) => {
        // this.dataArtist = res.model.data || []
        let dataArtist = res.model.data || []
        this.dataArtist = dataArtist.map(item => {
          item.order_count = item.order_count * 1
          item.order_money = item.order_money * 1
          return item
        })
      });
      platformDetailTrade(form).then((res) => {
        // this.dataTrade = res.model.data || []
        let dataTrade = res.model.data || []
        this.dataTrade = dataTrade.map(item => {
          item.order_count = item.order_count * 1
          item.order_money = item.order_money * 1
          return item
        })
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['order_money', 'order_count'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_percent_money":
            case "order_percent_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + "%";
              break;
          }
        }
      });
      return sums
    },
    //导出
    async exportExcel() {
      try {
        const form = {
          year: this.searchCondition.year,
          platform_name: this.searchCondition.platformName,
          platform_code: this.searchCondition.platformCode
        }
        let name = `${ this.searchCondition.year }年${ this.searchCondition.platformName }的单量和订单金额统计报告`
        const response = await exportPlatformDetail(form).then(response => {
          return response
        })

        this.$refs.refExportLink.exportSaveXlsx(response, name)

      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }


      // const timestamp = new Date().getTime();
      // const params = qs.stringify(searchCondition);
      // let url = `${ exportUrl }/api/dashboard/export?t=${ timestamp }&token=${ this.getToken() }&${ params }`
      // window.open(url)
    },
  }
}
</script>

<style scoped>

</style>
